import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const modelManagerTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      textEmphasis: theme.color.text.core['-emphasis'],
      textPrimary: theme.color.text.core['-primary'],
      textSecondary: theme.color.text.core['-secondary'],
      tableHeaderBg: theme.color.surface[2],
      tableRowBg: theme.color.grid.stripe,
      tableRowBgEven: theme.color.grid.base,
      tableColumnBorder: theme.color.surface[3],
      tableDropdownBg: theme.color.surface[1],
      tableDropdownGroupTitle: theme.color.text.core['-tertiary'],
      tagBg: theme.color.surface[2],
      inputBorder: theme.color.surface[4],
      tagText: theme.color.text.core['-secondary'],
      textLink: theme.color.text.core['-link'],
      moss1: theme.color.dataVis.qualitative['moss-1'],
      moss2: theme.color.dataVis.qualitative['moss-2'],
      headerSecondaryBG: theme.color.surface[1],
      model: {
        headerPrimaryBG: theme.color.surface.cool[2],
        headerSecondaryBG: theme.color.surface[1],
        tagText: theme.color.surface[0],
        tagBorder: theme.color.surface[4],
        sidebarBG: theme.color.surface[1],
        sectionGroupBG: theme.color.surface[0],
        mainSectionBG: theme.color.surface[4],
        mainHeaderBG: theme.color.surface[0],
        visualizerBG: theme.color.surface[3],
        floatingWindowBG: theme.color.surface.cool[2],
        floatingWindowBorder: theme.color.lighting['deboss-shadow'],
        cardBG: theme.color.surface[0],
      },
      deployToggle: {
        background: theme.color.focus[6],
        border: theme.color.focus[4],
        glow: theme.color.lighting['action-teal'],
        highlight: theme.color.lighting['highlight-1'],
      },
    },
  ]),
);
